import axios from 'axios'
import { baseURL } from './config.js'

const api = {
  users: {
    get: params => axios.get(`${baseURL}/users`, {
      params
    }),
    setRoles: (id, roles) => axios.post(`${baseURL}/users/${id}/roles`, {
      roles,
      _method: 'PUT'
    })
  }
}

export default api
